var map = {
	"./1_12.webp": 2998,
	"./arrow.png": 3021,
	"./background.webm": 800,
	"./background.webp": 7477,
	"./case.png": 3452,
	"./case_lose.png": 1758,
	"./case_win.png": 3611,
	"./circle.webp": 5369,
	"./click.mp3": 9781,
	"./drum.webp": 7461,
	"./false.mp3": 6884,
	"./lenta.webp": 7991,
	"./lentafake.webp": 9194,
	"./logo.png": 3153,
	"./melodia.mp3": 1652,
	"./odin.jpg": 2632,
	"./priz.png": 5567,
	"./priz_open.png": 2044,
	"./sector2.png": 4570,
	"./sector4.png": 1724,
	"./success.mp3": 7148,
	"./vrash.png": 8870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;